import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@reduxjs/toolkit';

import { getPartnerOrderShow } from 'store/widgets/PartnerOrder/common/selectors';
import { safeLazy } from 'utils/safeLazy';

const PartnerOrderPopup = safeLazy(
  () =>
    import(
      /* webpackChunkName: "PartnerOrderPopup" */
      './index'
    ),
);

const mapStateToProps = (state) => ({
  shouldRender: getPartnerOrderShow(state),
});

export default compose(connect(mapStateToProps), withRenderFlag)(PartnerOrderPopup);
